import { Crown, ShieldCheck, UserCog, PenLine } from "lucide-react";
const roles = [{
  icon: Crown,
  name: "Owner",
  desc: "Control total de la cuenta: facturación, plan, configuración general y gestión del equipo. Disponible en todos los planes.",
  planes: "Todos los planes"
}, {
  icon: UserCog,
  name: "Admin",
  desc: "Gestiona usuarios, configura el espacio de trabajo y supervisa la operación, sin acceso a la facturación.",
  planes: "Standard en adelante"
}, {
  icon: ShieldCheck,
  name: "Oficial de Cumplimiento",
  desc: "Revisa, valida y aprueba expedientes. Toma las decisiones de cumplimiento y firma los avisos antes de su presentación.",
  planes: "Pro y Enterprise"
}, {
  icon: PenLine,
  name: "Capturista",
  desc: "Ingresa datos y arma expedientes en el flujo guiado, sin permisos para aprobar ni modificar la configuración.",
  planes: "Pro y Enterprise"
}];
export default function RolesEquipo() {
  return <section data-section-id="REEMPLAZAR" id="roles" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Roles para <span className="text-primary font-mono">separar funciones</span>
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            La buena práctica de cumplimiento exige separar quién captura de quién aprueba. Notalia lo permite con roles diferenciados según tu plan.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {roles.map((rol, i) => {
          const Icon = rol.icon;
          return <div key={rol.name} data-index={i} className="p-6 rounded-lg bg-card border border-border hover:border-primary/40 transition-colors flex flex-col">
                <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center mb-4">
                  <Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-lg font-bold text-white mb-2">{rol.name}</h3>
                <p className="font-default text-sm text-slate-400 leading-relaxed flex-1">{rol.desc}</p>
                <span className="mt-4 inline-block font-mono text-xs uppercase tracking-wider text-primary/70 pt-3 border-t border-border">
                  {rol.planes}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}